import { render } from "./PlanHeroCard.vue?vue&type=template&id=24845fcc&scoped=true"
import script from "./PlanHeroCard.vue?vue&type=script&lang=ts"
export * from "./PlanHeroCard.vue?vue&type=script&lang=ts"

import "./PlanHeroCard.vue?vue&type=style&index=0&id=24845fcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24845fcc"

export default script